module.exports = __webpack_public_path__ + "media/1784278783562.8e04a9b1.mp4";